import { ExternalTableQueryDto, ExternalTableQuerySpecParameterDto } from "@/lib/apis/hub/models";

import { EXTERNAL_TABLE_DATE_PLACEHOLDER, EXTERNAL_TABLE_QUALIFIER_PLACEHOLDER } from "./formulaEditor.constants";
import { ExternalTableExpectedArg } from "./formulaEditor.types";

export function unquote(rawValue: string): string {
	const trimmedValue = (rawValue || "").trim();

	if (trimmedValue.startsWith('"')) {
		if (trimmedValue.endsWith('"') && trimmedValue.length >= 2) {
			return trimmedValue.substring(1, trimmedValue.length - 1);
		}

		return trimmedValue.substring(1);
	}

	return trimmedValue;
}

export function quote(rawValue: string): string {
	return `"${rawValue}"`;
}

function createExternalTableExpectedArg(insertText: string, detail: string): ExternalTableExpectedArg {
	return { insertText, detail };
}

function buildExternalTableParameterArg(
	parameter: ExternalTableQuerySpecParameterDto,
	index: number
): ExternalTableExpectedArg {
	if (parameter.type === "in_range") {
		return createExternalTableExpectedArg("0", `Paramètre ${index + 1} (intervalle)`);
	}

	return createExternalTableExpectedArg(
		quote(""),
		`Paramètre ${index + 1}${parameter.value ? ` (${parameter.value})` : ""}`
	);
}

export function getExternalTableExpectedArgs(query: ExternalTableQueryDto): ExternalTableExpectedArg[] {
	const qualifierArgs = query.table?.filterVersionsByQualifier
		? [createExternalTableExpectedArg(quote(EXTERNAL_TABLE_QUALIFIER_PLACEHOLDER), "Qualifier")]
		: [];

	const dateArg = createExternalTableExpectedArg(quote(EXTERNAL_TABLE_DATE_PLACEHOLDER), "Date");
	const parameterArgs = (query.querySpec?.parameters || []).map((parameter, index) =>
		buildExternalTableParameterArg(parameter, index)
	);

	return [...qualifierArgs, dateArg, ...parameterArgs];
}
